import { render, staticRenderFns } from "./PointDurForm.vue?vue&type=template&id=6e26006d"
import script from "./PointDurForm.vue?vue&type=script&lang=js"
export * from "./PointDurForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports